import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doUpdateAccountLocale),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(watchAccountLocaleSagas);

import { call, fork, put, select, spawn, takeEvery } from 'redux-saga/effects';
import { hideModal } from 'redux/modules/modals';
import { isLoggedIn } from 'redux/saga/selectors';
import { setCookie } from 'redux/saga/helpers/cookies';
import { gtmSafeRedirect } from 'redux/saga/helpers';
import { ga } from 'helpers/multitrack';
export var UPDATE_ACCOUNT_LOCALE = 'UPDATE_ACCOUNT_LOCALE';
export var updateAccountLocale = function updateAccountLocale(locale) {
  return {
    type: UPDATE_ACCOUNT_LOCALE,
    locale: locale
  };
};
export function doUpdateAccountLocale(client, _ref) {
  var locale, loggedIn;
  return regeneratorRuntime.wrap(function doUpdateAccountLocale$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          locale = _ref.locale;
          _context.next = 3;
          return spawn(ga, 'Locale Switched', 'Changed', locale);

        case 3:
          _context.next = 5;
          return spawn(ga, 'Footer', 'Click - Updated Locale', locale);

        case 5:
          _context.next = 7;
          return select(isLoggedIn);

        case 7:
          loggedIn = _context.sent;

          if (!loggedIn) {
            _context.next = 11;
            break;
          }

          _context.next = 11;
          return call(client.users.updateUserProfile, {
            locale: locale
          });

        case 11:
          _context.next = 13;
          return put(hideModal('LocaleModal'));

        case 13:
          setCookie('locale', locale, {
            path: '/'
          });
          _context.next = 16;
          return call(gtmSafeRedirect, window.location.href);

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function watchAccountLocaleSagas(client) {
  return regeneratorRuntime.wrap(function watchAccountLocaleSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fork(takeEvery, UPDATE_ACCOUNT_LOCALE, doUpdateAccountLocale, client);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}